import React from 'react';

import { type BaseSvgProps, colorToHexCode } from '../../utils';

export const Search = ({
  width = 12,
  primaryColorHexCode = colorToHexCode.black,
  'data-testid': testId,
}: BaseSvgProps) => (
  <svg
    data-testid={testId}
    width={width}
    height={width}
    className="shrink-0"
    viewBox="-3 -3 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 0C1.7909 4.74968e-05 0 1.79089 0 4C0 6.20911 1.7909 7.99995 4 8C4.94431 8 5.81184 7.67224 6.49609 7.125L9.37109 10L10.292 9.0791L7.36914 6.15527C7.76796 5.53314 8 4.79385 8 4C8 1.79086 6.20914 0 4 0ZM4 1.32422C5.47805 1.32422 6.67676 2.52195 6.67676 4C6.67676 5.47805 5.47805 6.67578 4 6.67578C2.52199 6.67573 1.32422 5.47802 1.32422 4C1.32422 2.52198 2.52199 1.32427 4 1.32422Z"
      fill={primaryColorHexCode}
    />
  </svg>
);
